import { useEffect, useState } from "react";
import Joyride, { CallBackProps, STATUS, Step, EVENTS, Events } from 'react-joyride';
import useWelcomeJourney from "../../hooks/useWelcomeJourney";
import StepComponent from "./StepComponent";
import useTranslation from "../../hooks/useTranslation";
import { useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

interface WelcomeJourneyJoyrideProps {
    page: string;
    addStepsStart: boolean;
    updatedStepIndex?: number;
    resetUpdatedStepIndex? : () => void;
};

const WelcomeJourneyJoyride: React.FC<WelcomeJourneyJoyrideProps> = (
    {
        page,
        addStepsStart,
        updatedStepIndex,
        resetUpdatedStepIndex
    }
) =>
{
    const trans = useTranslation("WelcomeJourneyJoyride");
    const welcomejourney = useWelcomeJourney(); 
    const [joyrideRun, setJoyrideRun] = useState<boolean>(false);
    const [stepIndex, setStepIndex] = useState<number | undefined>(0);
    const [comboBoxOpened, setComboboxOpened] = useState<boolean | undefined>(false);
    const [steps, setSteps] = useState<Step[]>();
    const location = useLocation();
    const auth = useAuth();

    useEffect(()=>{
        if(addStepsStart)
        {
          setTimeout(() => {    
            addSteps();
            if(resetUpdatedStepIndex)
              resetUpdatedStepIndex();
          }, 500);
        }
    },[addStepsStart]);

    useEffect(()=>{
      console.log(updatedStepIndex);
    });

    useEffect(()=>{
      setStepIndex(updatedStepIndex)
    },[updatedStepIndex]);

    const addSteps = () => {
        if (welcomejourney?.journey?.journeyStages.find((x) => { 
          return (x.isCompleted == false && x.journeyStageId == 3)
        }))
        {
         if(page == "UserManagement")
         {
            setSteps([
                {
                  content: <StepComponent textValue={trans.fetchLabelKeyTranslation("JoyrideEditKey", "Click here to access profile and assign license")} ></StepComponent>,
                  target: '.welcomejoyride-edit',
                  placement: 'right',
                  spotlightClicks: true,
                  disableBeacon: true,
                  disableOverlayClose: true,
                  hideFooter: true,
                  placementBeacon: 'right-end',
                  styles:{
                    options: {
                      width:200
                    },
                  }
                }
              ]);
         }
        else
        {
            setSteps([
            {
                content: <StepComponent textValue={trans.fetchLabelKeyTranslation("JoyrideLicenseKey", "Click here to assign license")} ></StepComponent>,
                target: '.welcomejoyride-license',
                placement: 'right',
                placementBeacon: 'right-end',
                spotlightClicks: true,
                disableBeacon: true,
                disableOverlayClose: true,
                hideCloseButton: true,
                hideFooter: true,
                styles:{
                options: {
                    width:200
                }
                }
            },
            {
                content: <StepComponent textValue={trans.fetchLabelKeyTranslation("JoyrideListItemKey", "Select a license")} ></StepComponent>,
                target: '.k-list-item',
                spotlightClicks: true,
                disableBeacon: true,
                disableOverlayClose: true,
                hideCloseButton: true,
                hideFooter: true
            },
            {
                content: <StepComponent textValue={trans.fetchLabelKeyTranslation("JoyrideSaveKey", "Save your changes")}></StepComponent>,
                target: '.welcomejoyride-save',
                spotlightClicks: true,
                disableBeacon: true,
                disableOverlayClose: true,
                hideFooter: true
            }
            ]);
        }
      }
      else if(welcomejourney?.journey?.journeyStages.find((x) => { 
        return (x.isCompleted == false && x.journeyStageId == 4)
      }))
        {
        setSteps([
          {
            content: <StepComponent textValue={trans.fetchLabelKeyTranslation("JoyrideEnableLoginKey", "Click here to enable/disable logins")}></StepComponent>,
            target: '.welcomejoyride-enablelogin',
            placement: 'right',
            spotlightClicks: true,
            disableBeacon: true,
            disableOverlayClose: true,
            placementBeacon: 'right-end',
            hideFooter: true,
            styles:{
              options: {
                width:200
              },
            }
          }
        ]);
      }
      else if (welcomejourney?.journey?.journeyStages.find((x) => { 
        return (x.isCompleted == false && x.journeyStageId == 5)
      })){
        setSteps([
          {
            content: <StepComponent textValue={trans.fetchLabelKeyTranslation("JoyrideEditBtnKey", "Click here to edit permissions")}></StepComponent>,
            target: '.welcomejoyride-editbtn',
            spotlightClicks: true,
            disableBeacon: true,
            disableOverlayClose: true,
            hideFooter:true
          },
          {
            content: <StepComponent textValue={trans.fetchLabelKeyTranslation("JoyrideViaPeopleKey", "Update playback network via the people")}></StepComponent>,
            target: '.welcomejoyride-viapeople',
            placement: 'top',
            spotlightClicks: true,
            disableBeacon: true,
            disableOverlayClose: true,
            hideFooter:true
          },
          {
            content: <StepComponent textValue={trans.fetchLabelKeyTranslation("JoyrideButtonUpdateKey", "Update your changes")}></StepComponent>,
            target: '.welcomejoyride-buttonupdate',
            spotlightClicks: true,
            disableBeacon: true,
            disableOverlayClose: true,
            hideFooter:true
          }
        ]);
      }  
      };
      
          useEffect(()=> {
            if(welcomejourney?.journeyActive){
              if(welcomejourney?.journeyRunning)
              {
                if (welcomejourney?.journey?.journeyStages.find((x) => { 
                  return (x.isCompleted == false && x.journeyStageId == 3)
                }))
                {
                  welcomejourney?.displayToolTip(false);
                  setJoyrideRun(true);
                }
                else if(welcomejourney?.journey?.journeyStages.find((x) => { 
                  return (x.isCompleted == false && x.journeyStageId == 5)
                }))
                {
                  welcomejourney?.displayToolTip(false);
                  setJoyrideRun(true);
                }
                else{
                  welcomejourney?.displayToolTip(true);
                  setJoyrideRun(false);
                }
              }
              else{
                welcomejourney?.displayToolTip(true);
                setJoyrideRun(false);
              }
            }
            else{
              welcomejourney?.displayToolTip(false);
              setJoyrideRun(false);
            }
    
          },[welcomejourney?.journeyActive, welcomejourney?.journeyRunning, page]);
      
        const onJoyRideCallback = (data: CallBackProps) => {
          const { action, index, status, type } = data;
          if(action == "close")
          {
            welcomejourney?.updateJourneyRunning(false);
            setStepIndex(0);
            setJoyrideRun(false);
            welcomejourney?.displayToolTip(true);
            if(resetUpdatedStepIndex)
              resetUpdatedStepIndex();
          }
          else
          {
            if (([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND] as Events[]).includes(type)) {      
              if(stepIndex == 1)
              {
                setJoyrideRun(false);
                setComboboxOpened(true);
                setTimeout(() => {
                  setJoyrideRun(true);
                }, 400);
              }
              else if(stepIndex == 2){
                setComboboxOpened(false);
                setTimeout(() => {
                  setJoyrideRun(true);
                }, 1000);
              }
            }
          }
        };

    return (
        <Joyride        
        callback={onJoyRideCallback}
        run={joyrideRun}
        scrollOffset={64}
        scrollToFirstStep
        showProgress
        showSkipButton={false}
        hideBackButton={true}             
        stepIndex={stepIndex}
        steps={steps}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      />
    );
};

export default WelcomeJourneyJoyride;